'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _css = require('antd/lib/menu/style/css');

var _menu = require('antd/lib/menu');

var _menu2 = _interopRequireDefault(_menu);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  return _react2.default.createElement(
    _menu2.default,
    null,
    _react2.default.createElement(
      _menu2.default.Item,
      null,
      _react2.default.createElement(
        'a',
        null,
        '\u5207\u6362\u5E97\u94FA'
      )
    ),
    _react2.default.createElement(
      _menu2.default.Item,
      null,
      _react2.default.createElement(
        'a',
        null,
        '\u4E2A\u4EBA\u8BBE\u7F6E'
      )
    ),
    _react2.default.createElement(
      _menu2.default.Item,
      null,
      _react2.default.createElement(
        'a',
        { onClick: props.onLogout },
        '\u9000\u51FA\u767B\u5F55'
      )
    )
  );
};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/logout_menu.js
// module id = 1002
// module chunks = 0